module.exports = __webpack_public_path__ + "static/media/loughborough.9f6b01e4.webp";